export default {
  errors: {
    UNKNOWN_ERROR: "An unexpected error occurred. Please try again later.",
    AUTH_BAD_AUTHENTICATION: "Invalid authentication. Please try again.",
    AUTH_ROLE_NOT_FOUND: "Your user does not have administrator permissions.",
    AUTH_USER_ALREADY_REGISTERED: "This email is already registered.",
    AUTH_USER_NOT_FOUND: "User not found. Please check your email.",
    AUTH_BAD_INPUT_PARAMETER: "Invalid input data. Please check your information.",
    AUTH_BAD_TYPE_RENDERED: "An unexpected error occurred. Please try again.",
    AUTH_COMMON_ERROR: "An error occurred. Please try again.",
    AUTH_BAD_AUTH_CODE_TYPE: "Invalid authentication code type.",
    AUTH_RATE_LIMIT_EXCEEDED: "Too many requests. Please wait a moment and try again.",
    unknown: "An unexpected error occurred. Please try again later.",
  },
  shared: {
    step: {
      credentials: "Enter your email",
      verification: "Verify your email",
    },
    email: {
      label: "Email",
      placeholder: "your@email.com",
    },
    button: "Continue",
    error: {
      sendingCode: "Error sending code",
    },
    verify: {
      title: "We have sent a code to <strong>{{email}}</strong>",
      subtitle: "Enter the 6-digit code",
      codeLabel: "Verification code",
      changeEmail: "Not your email? Go back",
      resendCode: "Resend code",
      resendSuccess: "Code resent. Check your inbox.",
      error: {
        incompleteCode: "Please complete the 6-digit code",
        invalidCode: "Invalid or expired code",
        title: "Error",
        message: "The code you entered is not correct, please try again.",
      },
    },
  },
  login: {
    title: "Admin Panel",
    subtitle: "Access the management panel",
    brandSubtitle: "Decentralized management and governance",
    verify: {
      button: "Login",
    },
  },
}
